<template>
    <div class="container">
        <b-modal id="agentLoaderModal" title="読み込み中" hide-footer hide-header-close no-close-on-esc
            no-close-on-backdrop centered header-bg-variant="primary" header-text-variant="light">

            <div class="text-center my-3" v-if="!message" aria-live="polite">
                読み込み中
            </div>

            <div class="text-center my-3" v-else aria-live="polite">
                {{ message }}
            </div>

            <div class="d-flex justify-content-center mb-5">
                <div class="spinner-border" role="status"></div>
            </div>

            <div class="text-center mb-5"></div>

        </b-modal>
    </div>
</template>

<script>
export default {
    components: {
    },
    props: {
    },
    data() {
        return {
            message: "", // Default value for the message
        };
    },
    mounted() {
    },
    methods: {
        openAgentLoaderModal(message = null) {
            console.log(message);

            if (message !== null) {
                this.message = message;
            } else {
                this.message = '';
            }

            this.$bvModal.show('agentLoaderModal');
        },
        closeAgentLoaderModal() {
            this.$bvModal.hide('agentLoaderModal');
        },
    },
};
</script>